module.exports = __webpack_public_path__ + "static/img/4.077e9161.png";